import { render, staticRenderFns } from "./HotPositionsForm.vue?vue&type=template&id=af625e7e&scoped=true"
import script from "./HotPositionsForm.vue?vue&type=script&lang=js"
export * from "./HotPositionsForm.vue?vue&type=script&lang=js"
import style0 from "./HotPositionsForm.vue?vue&type=style&index=0&id=af625e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af625e7e",
  null
  
)

export default component.exports